var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import ButtonLoader from '../ButtonLoader';
import { Link } from 'react-router-dom';

var A = function A(p) {
  return React.createElement('a', p);
};
var B = function B(p) {
  return React.createElement('button', p);
};
var L = function L(p) {
  return React.createElement(Link, p);
};
var I = function I(p) {
  return React.createElement('label', p);
};

var Button = function Button(_ref) {
  var isLoading = _ref.isLoading,
      className = _ref.className,
      children = _ref.children,
      Component = _ref.component,
      others = _objectWithoutProperties(_ref, ['isLoading', 'className', 'children', 'component']);

  return React.createElement(
    Component,
    _extends({
      disabled: isLoading
    }, others, {
      className: '' + className + (isLoading ? ' loading' : '') }),
    isLoading && React.createElement(ButtonLoader, null),
    children
  );
};

var LabelButton = function LabelButton(props) {
  return React.createElement(Button, _extends({}, props, { component: I }));
};
var LinkButton = function LinkButton(props) {
  return React.createElement(Button, _extends({}, props, { component: L }));
};
var HrefButton = function HrefButton(props) {
  return React.createElement(Button, _extends({}, props, { component: A }));
};
var RegularButton = function RegularButton(props) {
  return React.createElement(Button, _extends({}, props, { component: B }));
};

Button.propTypes = {
  /** Boolean that controls if the button is in loading state or not */
  isLoading: PropTypes.bool,
  /** Css class name */
  className: PropTypes.string,
  /** Errors output */
  error: PropTypes.array
};

export default (function (props) {
  if (props.href) return React.createElement(HrefButton, props);
  if (props.to) return React.createElement(LinkButton, props);
  if (props.for) return React.createElement(LabelButton, props);

  return React.createElement(RegularButton, props);
});